import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const DarkModeToggle = ({ variant = 'icon', className = '' }) => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  if (variant === 'switch') {
    return (
      <div className={`flex items-center gap-3 ${className}`}>
        <Sun className={`w-4 h-4 ${isDarkMode ? 'text-gray-400 dark:text-gray-500' : 'text-yellow-500'}`} />
        <button
          onClick={toggleDarkMode}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
            isDarkMode ? 'bg-primary-500' : 'bg-gray-300'
          }`}
          role="switch"
          aria-checked={isDarkMode}
          aria-label="Toggle dark mode"
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
              isDarkMode ? 'translate-x-6' : 'translate-x-1'
            }`}
          />
        </button>
        <Moon className={`w-4 h-4 ${isDarkMode ? 'text-violet-400' : 'text-gray-400 dark:text-gray-500'}`} />
      </div>
    );
  }

  if (variant === 'button') {
    return (
      <button
        onClick={toggleDarkMode}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all ${
          isDarkMode 
            ? 'bg-gray-700 text-gray-200 hover:bg-gray-600' 
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        } ${className}`}
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDarkMode ? (
          <>
            <Sun className="w-4 h-4" />
            <span className="text-sm font-medium">Light Mode</span>
          </>
        ) : (
          <>
            <Moon className="w-4 h-4" />
            <span className="text-sm font-medium">Dark Mode</span>
          </>
        )}
      </button>
    );
  }

  return (
    <button
      onClick={toggleDarkMode}
      className={`inline-flex items-center justify-center px-2.5 py-1.5 rounded-lg border transition-colors ${
        isDarkMode 
          ? 'bg-grey-800 border-grey-600 text-yellow-400 hover:bg-grey-700' 
          : 'bg-white border-grey-300 text-grey-700 hover:bg-grey-50'
      } ${className}`}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? (
        <Sun className="w-4 h-4" />
      ) : (
        <Moon className="w-4 h-4" />
      )}
    </button>
  );
};

export default DarkModeToggle;
